export default "__VITE_ASSET__e8360ce3__"